const normalizeError = (error: unknown): Error => (error instanceof Error ? error : new Error(String(error)));

export const captureException = (error: unknown, operation: string): void => {
  const cause = normalizeError(error);
  const reported = new Error(`${operation}: ${cause.message}`);
  reported.stack = cause.stack;
  const reportError = (globalThis as typeof globalThis & { reportError?: (exception: unknown) => void }).reportError;
  if (reportError) {
    reportError(reported);
    return;
  }

  // eslint-disable-next-line no-console -- Browser fallback when no error reporter is installed.
  console.error(reported);
};
